export const TenantDomains = {
    localhost: 'localhost',
    dev: 'dev',
    cezep: 'cezep',
    lm: 'lm',
    ksystem: 'ksystem'
} as Record<string, Tenants>;

export type Tenants = 'localhost' | 'dev' | 'cezep' | 'lm' | 'ksystem';
